const contractTypeData = {
	data: [
		{ key: 'Marker', value: ['MAR', 'CMK'] },
		{ key: 'Appointment Group', value: ['AG1', 'AG2', 'AG3'] },
		{ key: 'Ad Hoc', value: ['AH1', 'AH2'] },
		{ key: 'Invigilator', value: ['I1', 'I2'] },
		{ key: 'Verifier', value: ['V1', 'V2'] }
	],
	errors: []
};

const appointmentTypesData = {
	'Marker': {
		count: 2,
		data: [
			"CMK",
			"MAR"
		],
		errors: []
	},
	'Appointment Group': {
		count: 5,
		data: [
			"MSL",
			"PA",
			"QPV",
			"VA",
			"VE"
		],
		errors: []
	},
	'Ad Hoc': {
		count: 4,
		data: [
			"AHG",
			"MCE",
			"MCM",
			"MCR"
		],
		errors: []
	},
	'Invigilator': {
		count: 2,
		data: [
			"INV",
			"WIN"
		],
		errors: []
	},
	'Verifier': {
		count: 1,
		data: [
			"MD"
	  	],
		errors: []
	},
};

export { contractTypeData, appointmentTypesData };
